import React, { FC } from 'react'

import { Typography, FSMBtnNext, FNOLPageWrapper, useTranslate } from '@dg-shared'
import { CommonPageProps } from '../../../types/interface/fsm.interface'
import { Events } from '../../../FSM/shared/constants'
import { useFNOLStyles } from '../shared/styles/useStyles'
import { TRANSLATIONS as T } from '../../../constants'

const PageMoreInfo: FC<CommonPageProps> = ({ service, currentState }) => {
  const FNOLClasses = useFNOLStyles({})
  const { t } = useTranslate(`${T.COLLISION}.moreDetails`)
  const { send } = service

  return (
    <FNOLPageWrapper breadcrumbsBtnText={t(`${T.COMMON}/back`)} breadcrumbsStepPercentage={50}>
      <Typography testId='title' type='h1' className={FNOLClasses.title}>
        {t('title')}
      </Typography>
      <Typography testId='subtitle' html={true} className={FNOLClasses.description}>
        {t('subtitle')}
      </Typography>
      <FSMBtnNext
        testId='nextButton'
        handleClick={() => send({ type: Events.NEXT, state: currentState })}
        buttonText={t(`${T.COMMON}/next`)}
      />
    </FNOLPageWrapper>
  )
}

export default PageMoreInfo
